import ReactOnRails from "react-on-rails";
import ChallengeTableSection from "../src/features/sections/challenge-table-section/ChallengeTableSection";

ReactOnRails.register({ ChallengeTableSection });
